export const getProductAnchor = (title) => {
    if (!title) return '';
    return title.toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
};
